import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { AssetShipment } from '../models/entities/asset-shipment';
import { AssetShipmentRequest } from '../models/dto/asset-shipment-request';
import { Asset } from 'src/app/assabil-kernel/models/entities/master-data/asset';

@Injectable({
  providedIn: 'root'
})
export class AssetShipmentService {

  constructor(private networkService: LeanNetworkService,  public userService : UserService) { }

  
  //-----------------------------------------------------------------------------------------------------
  assetShipmentsGet(assetShipmentCode: string, branchCode : string,
      booleans        : boolean[],
      startDate? : Date, endDate? : Date)  : Promise<AssetShipment[]> {
    let request       : BaseRequest = new BaseRequest(this.userService.userInfo);

    if (!branchCode) branchCode = '.';
    request.code    = assetShipmentCode;
    request.strArg1 = branchCode;				
    request.booleans = booleans;				
    request.dteArg1 = startDate;
    request.dteArg2 = endDate;
 
    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetShipmentsGet', request).then(result => {
          return resolve(result.assetShipments);
        }, error => {
            reject(error);
        });
    });
  }


  //-----------------------------------------------------------------------------------------------------
  assetShipmentGet(assetShipmentCode : string)  : Promise<AssetShipment> {
    let request       : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.code    = assetShipmentCode;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetShipmentGet', request).then(result => {
          return resolve(result.assetShipment);
        }, error => {
            reject(error);
        });
    });
  }

  //-----------------------------------------------------------------------------------------------------
  assetShipmentSave(assetShipment : AssetShipment)  : Promise<AssetShipment> {
    let request       : AssetShipmentRequest = new AssetShipmentRequest(this.userService.userInfo);
    request.assetShipment    = assetShipment;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetShipmentSave', request).then(result => {
          return resolve(result.assetShipment);
        }, error => {
            reject(error);
        });
    });
  }
  
  //-----------------------------------------------------------------------------------------------------
  assetShipmentAssetAdd(assetShipmentCode : string, barCode : string)  : Promise<Asset> {
    let request       : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.code    = assetShipmentCode;
    request.strArg1 = barCode;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetShipmentAssetAdd', request).then(result => {
          return resolve(result.asset);
        }, error => {
            reject(error);
        });
    });
  }

  //-----------------------------------------------------------------------------------------------------
  assetShipmentAssetRemove(assetShipmentCode : string, barCode : string)  : Promise<boolean> {
    let request       : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.code    = assetShipmentCode;
    request.strArg1 = barCode;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetShipmentAssetRemove', request).then(result => {
          return resolve(true);
        }, error => {
            reject(error);
        });
    });
  }

  //-----------------------------------------------------------------------------------------------------
  assetShipmentShip(assetShipmentCode : string)  : Promise<AssetShipment> {
    let request       : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.code    = assetShipmentCode;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetShipmentShip', request).then(result => {
          return resolve(result.assetShipment);
        }, error => {
            reject(error);
        });
    });
  }
  
  //-----------------------------------------------------------------------------------------------------
  assetShipmentClose(assetShipmentCode : string)  : Promise<AssetShipment> {
    let request       : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.code    = assetShipmentCode;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetShipmentClose', request).then(result => {
          return resolve(result.assetShipment);
        }, error => {
            reject(error);
        });
    });
  }
}

